import React from 'react';
import { Modal } from '@shopee/chatbot-ui';
import { getTrans } from '@/utils/instantLoaded/tools';
import './style.scss';

interface Props {
  active: boolean
  setActive: (isActive: boolean) => void
  closeModal?: () => void
  confirmModal?: () => void
}

function EndConfirmModal(props: Props) {
  const { active, setActive, closeModal, confirmModal } = props;

  return (
    <Modal
      active={active}
      title=""
      contentContainerClassName="livechat-end-modal"
      contentClassName="livechat-end-modal-content"
      onClose={() => setActive(false)}
      footer={{
        layout: 'horizontal',
        buttons: [
          {
            style: { color: 'rgba(0, 0, 0, 0.87)' },
            text: getTrans('modal_later_text'),
            onClick: () => {
              setActive(false);
              closeModal?.();
            },
          },
          {
            text: getTrans('modal_end_text'),
            onClick: () => {
              setActive(false);
              confirmModal?.();
            },
          },
        ],
      }}
    >
      {getTrans('chat_bot_close_tip_content')}
    </Modal>
  );
}

export default EndConfirmModal;
